import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { StaticDateSpan } from '@mint-lib/tw-components/patterns';

import { RagTableType } from '../../../../types/rag.js';

const UploadedDateCell = ({ data }: ICellRendererParams<RagTableType>) => {
  if (!data?.uploadedDate) {
    return null;
  }

  return <StaticDateSpan date={data.uploadedDate} />;
};

export { UploadedDateCell };
